import { useState, useEffect } from "react";
import {
  Select,
  Button,
  Icon,
} from "semantic-ui-react";
import { Subject } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { PostForm } from "../PostForm";
import { BasicModal } from "../../../Shared";
import { useNavigate, useLocation } from "react-router-dom";
import queryString from "query-string";
import "./Navbar.scss";

const subjectController = new Subject();

export function Navbar(props) {
  const { onReload, filters, setFilters, setCurrentPage, setFiltersInitialized } = props;
  const { accessToken } = useAuth();
  const [subjectsOptions, setSubjectsOptions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);

  const sortOptions = [
    { key: "", value: "", text: "Selecciona un orden" },
    { value: "createdAt", text: "Más recientes" },
    { value: "votes", text: "Más votadas" },
    { value: "unanswered", text: "Sin respuesta" },
  ];

  const updateURL = (newFilters) => {
    const query = queryString.stringify(newFilters);
    navigate(`${location.pathname}?${query}`);
  };

  const handleChange = (e, { name, value }) => {
    const newFilters = {
      ...filters,
      [name]: value,
    };
    setFilters(newFilters);
    setCurrentPage(1);
    updateURL(newFilters);
  };

  useEffect(() => {
    (async () => {
      try {
        setSubjectsOptions([]);
        const response = await subjectController.getSubjects(accessToken);
        const options = response.map((subject) => ({
          value: subject.id,
          text: subject.name,
        }));
        setSubjectsOptions([
          { key: "", value: "", text: "Selecciona una asignatura" },
          ...options,
        ]);
      } catch (error) {
        // Error loading subjects
      }
    })();
  }, [accessToken]);

  useEffect(() => {
    const parsed = queryString.parse(location.search);
    if (!parsed.order) {
      parsed.order = "";
    }
    if (!parsed.subjectId) {
      parsed.subjectId = "";
    }
    parsed.subjectId = parseInt(parsed.subjectId) || "";

    // Solo establecer filtros desde URL en la carga inicial
    if (!isInitialized) {
      setFilters(parsed);
      setFiltersInitialized(true);
      setIsInitialized(true);
    }
  }, [location.search, setFilters, isInitialized, setFiltersInitialized]);

  return (
    <div className="student-forum-navbar">
      <div className="student-forum-navbar__filters">
        <div className="student-forum-navbar__filters-left">
          <Select
            name="subjectId"
            className="edunova-select"
            placeholder="Selecciona una asignatura"
            options={subjectsOptions}
            value={filters.subjectId}
            onChange={handleChange}
            clearable
          />
          <Select
            name="order"
            className="edunova-select"
            placeholder="Filtrar por"
            options={sortOptions}
            value={filters.order}
            onChange={handleChange}
            clearable
          />
        </div>
        <div className="student-forum-navbar__filters-right">
          <Button primary onClick={onOpenCloseModal}>
            <Icon name="plus" /> Crear publicación
          </Button>
        </div>
      </div>
      <BasicModal
        show={showModal}
        size="large"
        close={onOpenCloseModal}
        title="Crear publicación"
      >
        <PostForm
          onReload={onReload}
          onClose={onOpenCloseModal}
          subjectsOptions={subjectsOptions}
        />
      </BasicModal>
    </div>
  );
}
